class FAQS {
  static elemGetSectionId = (elem) => elem.getAttribute('data-section-idx');

  constructor() {
    this.lists = document.querySelectorAll('.faq-entries-list');
    this.sectionsLinks = document.querySelectorAll('.faq-section-title');
    this.sectionSelect = document.querySelector('.faq-section-select');

    // Section click handler
    this.sectionsLinks.forEach(elem => elem.addEventListener('click', this.handleSectionClick));

    // Section Select handler
    this.sectionSelect.addEventListener('change', this.handleSectionSelect);

    // Entry toggle handler
    let __this = this;
    this.lists.forEach(listElem => listElem.querySelectorAll('.faq-entry')
      .forEach(entryElem => entryElem.addEventListener('click', this.toggleEntry.bind(__this)))
    );

    // TRW 01/12/2021
    this.setDefaultFAQSectionActive();  
    
  }

  // TRW 01/12/2021
  setDefaultFAQSectionActive() {
    let searchKeyword = this.getParameterByName('faq') || 'general';
    let faqSectionElem = document.querySelector('.faq-section-list [data-section="'+searchKeyword+'"]');
    if(faqSectionElem){
      let idx = faqSectionElem.getAttribute('data-section-idx') ? faqSectionElem.getAttribute('data-section-idx') : "0";
      this.changeSection(idx);
    }
  }
  
  // TRW 01/12/2021
  getParameterByName(name) {
    name = name.replace(/[[]/, "[").replace(/[]]/, "]");
    var regex = new RegExp("[\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replaceAll('+', ' '));
  }

  // TRW 02/09/2021
  hideFaqEntries(excludeElement = null){
    this.lists.forEach(listElem => listElem.querySelectorAll('.faq-entry')
      .forEach(entryElem => {
        if(excludeElement != entryElem){
          entryElem.classList.remove('open'); 
        }
      })
    );
  }

  changeSection = (idx) => {
    
    // Set active class to section
    this.sectionsLinks.forEach(
      elem => elem.classList[FAQS.elemGetSectionId(elem) === idx ? 'add' : 'remove']('active')
    );

    // Change select value
    this.sectionSelect.value = idx;

    // Update lists
    this.lists.forEach(elem => {
      const isTarget = FAQS.elemGetSectionId(elem) === idx;

      elem.classList[isTarget ? 'add' : 'remove']('active');

      // Close all entries
      if (isTarget) {
        elem.querySelectorAll('.faq-entry')
          .forEach(
            // Open first one
            (elem, idx) => elem.classList[idx === 0 ? 'add' : 'remove']('open')
          );
      }
    });
  };

  toggleEntry(e) {
    
    e.preventDefault();
    // TRW 02/09/2021
    this.hideFaqEntries(e.currentTarget);
    // Prevent toggle on text selection
    if (window.getSelection && typeof window.getSelection === 'function' && window.getSelection().toString()) {
      return;
    }

    e.currentTarget.classList.toggle('open');
  }

  handleSectionClick = (e) => {
    e.preventDefault();
    this.changeSection(FAQS.elemGetSectionId(e.currentTarget));
  };

  handleSectionSelect = (e) => {
    e.preventDefault();
    this.changeSection(this.sectionSelect.value);
  };
}

export default () => new FAQS();
